<template>
  <div class="connected-credentials-name">
    <div class="header">
      <div class="source-description">
        <div class="checkmark-holder">
          <img src="/images/v.svg" class="checkmark">
        </div>
        <div class="source-name-wrapper">
          <div class="card-title">{{ sourceName }}</div>
          <div v-if="!editing" class="subtitle">
            <div>{{ name }}</div>
            <icon v-if="allowEdit" :class="'edit-icon'"
                  :icon-name="'edit'" :fill="true" size="16px" @click="editing = true"/>
          </div>
          <div v-else>
            <update-creds-name-input :source="source" :callback="() => editing = false"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import BaseUI from '@riseupil/base-ui';
import UpdateCredsNameInput from '@/base-components/credentials/credentials-list/UpdateCredsNameInput.vue';

export default {
  name: 'ConnectedCredentialsName',
  components: {
    Icon: BaseUI.Icon,
    UpdateCredsNameInput,
  },
  props: {
    source: Object,
    allowEdit: Boolean,
  },
  data() {
    return {
      editing: false,
    };
  },
  computed: {
    sourceName() {
      return this.source.displayName;
    },
    name() {
      return this.source.name;
    },
    accounts() {
      return this.source.accounts;
    },
    type() {
      return this.source.type;
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '~@riseupil/base-ui/src/scss/riseup-colors';
  @import '../../../scss/mixins';

  .connected-credentials-name {
    text-align: right;
    .header {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .source-description {
        display: flex;

        .source-name-wrapper {
          display: flex;
          flex-direction: column;
          justify-content: center;

          .card-title {
            @include card-title;
            margin-bottom: 5px;
          }

          .subtitle {
            display: flex;
            align-items: center;

            .icon {
              margin-right: 8px;
              cursor: pointer;
            }
          }
        }

        .checkmark-holder {
          margin-left: 15px;
        }
      }
    }

  }
</style>
